export enum ColumnTypes {
    EVENT_TYPE = 'eventType',
    EVENT_CODE = 'eventCode',
    EVENT_SOURCE = 'eventSource',
    AUTHOR = 'author',
    RUNS = 'runs',
    SATISFACTION = 'satisfaction',
    DATE = 'date',
    PROMPT = 'prompt',
    RESPONSE = 'response',
    TYPE = 'type',
    COMMENT = 'comment',
}

export const COLUMN_CAPTIONS = {
    [ColumnTypes.EVENT_TYPE]: 'Event Type',
    [ColumnTypes.EVENT_CODE]: 'Event Code',
    [ColumnTypes.EVENT_SOURCE]: 'Event Source',
    [ColumnTypes.AUTHOR]: 'Author',
    [ColumnTypes.RUNS]: 'Runs',
    [ColumnTypes.SATISFACTION]: 'Satisfaction',
    [ColumnTypes.DATE]: 'Date',
    [ColumnTypes.PROMPT]: 'Prompt',
    [ColumnTypes.RESPONSE]: 'Response',
    [ColumnTypes.TYPE]: 'Type',
    [ColumnTypes.COMMENT]: 'Comment',
};

export const ColumnWidth = {
    [ColumnTypes.EVENT_TYPE]: '8rem',
    [ColumnTypes.EVENT_CODE]: '13rem',
    [ColumnTypes.EVENT_SOURCE]: '8rem',
    [ColumnTypes.AUTHOR]: '16rem',
    [ColumnTypes.RUNS]: '6rem',
    [ColumnTypes.SATISFACTION]: '12rem',
    [ColumnTypes.DATE]: '9rem',
};
